var map = {
	"./logo-akt.svg": 90197,
	"./logo-alter.svg": 67293,
	"./logo-amparch.svg": 7835,
	"./logo-andr.svg": 43840,
	"./logo-arch.svg": 1399,
	"./logo-atom.axv.svg": 7913,
	"./logo-atom.svg": 52276,
	"./logo-ausd.svg": 9368,
	"./logo-axl.svg": 11908,
	"./logo-axv.svg": 11678,
	"./logo-bcna.svg": 44553,
	"./logo-bld.svg": 48819,
	"./logo-bnusd.svg": 16781,
	"./logo-btsg.svg": 531,
	"./logo-busd.axv.svg": 14000,
	"./logo-busd.svg": 58665,
	"./logo-cmdx.svg": 8119,
	"./logo-const.svg": 23464,
	"./logo-core.svg": 73230,
	"./logo-cronos.svg": 5309,
	"./logo-cudos.svg": 54755,
	"./logo-dec.svg": 50493,
	"./logo-dvpn.svg": 31215,
	"./logo-eth.axl.svg": 73047,
	"./logo-flix.svg": 4878,
	"./logo-glto.svg": 6421,
	"./logo-grav.svg": 69365,
	"./logo-grvt8.svg": 97074,
	"./logo-inj.svg": 7424,
	"./logo-ist.svg": 86421,
	"./logo-jkl.svg": 16490,
	"./logo-juno.svg": 41921,
	"./logo-lse.svg": 57201,
	"./logo-lvn.svg": 48621,
	"./logo-mpwr.svg": 52491,
	"./logo-nibi.svg": 18363,
	"./logo-noimage.svg": 59057,
	"./logo-ntrn.svg": 82245,
	"./logo-osmo.svg": 87485,
	"./logo-pasg.svg": 96256,
	"./logo-pbb.svg": 2425,
	"./logo-plq.svg": 98252,
	"./logo-qwoyn.svg": 95667,
	"./logo-rock.svg": 53024,
	"./logo-sarch.svg": 83378,
	"./logo-sei.svg": 93672,
	"./logo-shd.svg": 58078,
	"./logo-stkosmo.svg": 33635,
	"./logo-test.svg": 47995,
	"./logo-usdc.axl.svg": 85135,
	"./logo-usdc.axv.svg": 71621,
	"./logo-usdc.grav.svg": 65428,
	"./logo-usdc.nobl.svg": 37013,
	"./logo-usdc.svg": 76944,
	"./logo-usdt.axv.svg": 86918,
	"./logo-usdt.grav.svg": 49213,
	"./logo-usdt.svg": 84447,
	"./logo-vdl.svg": 61727,
	"./logo-wbtc.axl.svg": 57580,
	"./logo-xakt.svg": 55347,
	"./logo-xarch.svg": 31725,
	"./logo-xatom.svg": 18270,
	"./logo-xaxl.svg": 84862,
	"./logo-xbcna.svg": 84539,
	"./logo-xbld.svg": 62409,
	"./logo-xbtsg.svg": 68877,
	"./logo-xcmdx.svg": 40641,
	"./logo-xconst.svg": 1418,
	"./logo-xcore.svg": 82600,
	"./logo-xcudos.svg": 6729,
	"./logo-xdec.svg": 37971,
	"./logo-xdvpn.svg": 3722,
	"./logo-xflix.svg": 91176,
	"./logo-xgrav.svg": 63887,
	"./logo-xinj.svg": 59114,
	"./logo-xjkl.svg": 68772,
	"./logo-xjuno.svg": 6467,
	"./logo-xlvn.svg": 94823,
	"./logo-xmpwr.svg": 19913,
	"./logo-xnibi.svg": 27057,
	"./logo-xosmo.svg": 44095,
	"./logo-xpasg.svg": 54110,
	"./logo-xplq.svg": 46662,
	"./logo-xqwoyn.svg": 91033,
	"./logo-xusdc.svg": 44910,
	"./logo-xvdl.svg": 75317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7003;